import Error from "components/Error";
import Modal from "components/modal/Modal";
import OutOfOfficeFormView from "pages/out-of-office/OutOfOfficeFormView";
import OutOfOfficeListView from "pages/out-of-office/OutOfOfficeListView";
import { useOutOfOfficeModal } from "pages/out-of-office/useOutOfOfficeModal";

interface Props {
  isShown: boolean;
  onClose: () => void;
}

const OutOfOfficeModal = ({ isShown, onClose }: Props) => {
  const {
    view,
    formMode,
    editingPeriod,
    periods,
    isLoading,
    listApiError,
    formApiError,
    isSubmitting,
    goToList,
    handleAdd,
    handleEdit,
    handleDelete,
    handleSubmit,
    handleClose,
  } = useOutOfOfficeModal(isShown, onClose);

  return (
    <Modal isShown={isShown} onClose={handleClose} showCloseButton maxWidthClassName="sm:max-w-2xl">
      {view === "list" ? (
        <div className="flex flex-col">
          {listApiError ? (
            <div className="mb-4">
              <Error error={listApiError} />
            </div>
          ) : null}
          <OutOfOfficeListView
            periods={periods}
            isLoading={isLoading}
            onAdd={handleAdd}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </div>
      ) : (
        <OutOfOfficeFormView
          key={editingPeriod?.id ?? "create"}
          mode={formMode}
          initialPeriod={editingPeriod}
          apiError={formApiError}
          isSubmitting={isSubmitting}
          onCancel={goToList}
          onSubmit={handleSubmit}
        />
      )}
    </Modal>
  );
};

export default OutOfOfficeModal;
